<div class="wm-signup-page">
  <div class="signup-main">
    <div class="signup-form-container">
      <div class="wm-signup-container">
        <div class="signup-form-header">
          Sign up for smarter testing.
        </div>
        <form class="wm-signup-form" [formGroup]="form">
          <div class="wm-signup-error" data-testing-id="login-errorfield" [hidden]="!signupFailure" [innerHtml]="signupFailure"></div>

          <div class="signup-form-item">
            <div class="signup-form-label">Email Address</div>
            <input autocomplete="false" type="text" pInputText formControlName="email" class="signup-form-input ui-inputtext ui-corner-all ui-widget"/>
          </div>
          <div class="signup-form-item">
            <div class="signup-form-label">Name</div>
            <input autocomplete="false" type="text" pInputText formControlName="username" class="signup-form-input ui-inputtext ui-corner-all ui-widget"/>
          </div>
          <div class="signup-form-item">
            <div class="signup-form-label">Organization or Company</div>
            <input autocomplete="false" type="text" pInputText formControlName="organization" class="signup-form-input ui-inputtext ui-corner-all ui-widget"/>
          </div>
          <div class="privacy-container">
            <p-checkbox name="enabled" formControlName="privacypolicy" [binary]="true"></p-checkbox>
            <div class="privacy-info">I agree to receive more information about webmate in accordance with the Testfabrik
              <a href="https://testfabrik.com/meta/datenschutz/" class="link" target="_blank">privacy policy</a></div>
            </div>

            @if (!signUpBusy) {
              <button pButton class="wm-signup-submitbutton" type="submit" [disabled]="!form.valid" (click)="submitSignup()" data-testing-id="login-submit-button">Sign up</button>
            }
            @if (signUpBusy) {
              <button pButton class="wm-signup-submitbutton" type="submit" [disabled]="true" data-testing-id="login-submit-button-busy">
                <fa-icon icon="spinner" animation="spin"></fa-icon>
                Signing up...
              </button>
            }
            <div class="wm-signup-login">
              <a routerLink="/login" data-testing-id="back-to-login-link">Back to login</a>
            </div>
          </form>
        </div>
        <div class="spacer"></div>
      </div>
      <div class="signup-info-container">
        <div class="signup-info-gradient">
          <div class="spacer"></div>
          <div class="signup-info-content">
            <div class="signup-info-logo">
              <img src="/assets/img/signup-webmate-logo.svg">
            </div>
            <div class="signup-info-list">
              <div class="content-header">Free 10-Day Trial</div>
              <div class="content-divider"></div>
              <div class="content-entry">
                <div class="entry-icon">
                  <fa-icon icon="check"></fa-icon>
                </div>
                <div class="entry-text">
                  Unlimited users
                </div>
              </div>
              <div class="content-entry">
                <div class="entry-icon">
                  <fa-icon icon="check"></fa-icon>
                </div>
                <div class="entry-text">
                  Access to real Android and iOS devices
                </div>
              </div>
              <div class="content-entry">
                <div class="entry-icon">
                  <fa-icon icon="check"></fa-icon>
                </div>
                <div class="entry-text">
                  2 virtual machine slots for parallel manual and automated testing
                </div>
              </div>
              <div class="content-entry">
                <div class="entry-icon">
                  <fa-icon icon="check"></fa-icon>
                </div>
                <div class="entry-text">
                  Unlimited access to the webmate API and SDKs
                </div>
              </div>
              <div class="content-entry">
                <div class="entry-icon">
                  <fa-icon icon="check"></fa-icon>
                </div>
                <div class="entry-text">
                  Explore test management and reports
                </div>
              </div>
            </div>
            <div class="signup-info-footer">
              <div class="footer-text">Enjoy testing like...</div>
              <div class="footer-logos">
                <img src="/assets/img/signup-allianz-logo.svg">
                <img src="/assets/img/signup-cornelsen-logo.svg">
                <img src="/assets/img/signup-douglas-logo.svg">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="signup-footer">
      <div class="footer-logo">
        <img src="/assets/img/signup-webmate-logo.svg">
      </div>
      <div class="footer-content" id="footer-privacy">
        <div class="footer-text">
          <a href="https://testfabrik.com/meta/datenschutz/" target="_blank" class="link">Privacy Policy</a>
        </div>
        <div class="footer-text" id="footer-tos">
          <a href="https://testfabrik.com/legal/tos/" target="_blank" class="link">Terms of Service</a>
        </div>
        <div class="footer-text" id="footer-docs">
          <a href="https://docs.webmate.io/first-steps/trial-period" target="_blank" class="link">webmate Docs</a>
        </div>
        <div class="footer-text" id="footer-website">
          <a href="https://testfabrik.com/" target="_blank" class="link">testfabrik.com</a>
        </div>
      </div>
    </footer>
  </div>
  <!-- Google Analytics -->
  <script>
    (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date();
    a = s.createElement(o),
    m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

    ga('create', 'UA-175971204-2', 'auto');
    ga('send', 'pageview');
  </script>
  <!-- End Google Analytics -->
